module.exports = __webpack_public_path__ + "media/images/pages/img_cover_right_09-70287c25adff7c385dc7e9087124bd31.jpg";